if ( typeof QuickBuy !== 'function' ) {

	class QuickBuy extends HTMLElement {
		
		constructor(){

			super();

			this.installmentPaymentType = "installment";
			this.normalPaymentType = "normal";
			this.hiddenVariantSelector = this.querySelectorAll('div[data-subscription]');
			this.listenersInitialized = false;

			// Product variant event listener for theme specific logic

			this.zIndex = 99;

			const hasProductItem = this.closest('[data-js-product-item]');

			this.productVariants = this.querySelector('product-variants');

			if ( hasProductItem ) {
				this.variantImages = this.querySelector('[data-js-quick-buy-product-images]');
				this.productImage = this.closest('[data-js-product-item]').querySelector('[data-js-product-item-image]');
				this.variantImagesSliders = this.hasAttribute('data-variant-images-slider');
				this.productSlider = this.closest('[data-js-product-item]').querySelector('css-slider');
			}

			this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
			this.onVariantChangeHandler({target:this.productVariants});

			if ( this.variantImages ) {

				setTimeout(()=>{
					const imageObserver = new IntersectionObserver((entries, observer) => {
						if ( ! entries[0].isIntersecting ) {
							return;
						} else {
							this.variantImages.querySelectorAll(`template`).forEach(elm=>{
								if ( ! elm.dataset.init ) {
									this.initVariantImage(elm);
								}
							});
							observer.unobserve(this);
						}
					});
					imageObserver.observe(this);
				}, 5000)
			
			}

			setTimeout(()=>{

				this.querySelectorAll('.product-variant__item--radio').forEach(elm=>{

					elm.addEventListener('click', e=>{

						elm.closest('.css-slider-holder').scrollTo({
							top: 0,
							left: elm.offsetLeft - 40,
							behavior: 'smooth'
						});

						if ( elm.classList.contains('product-variant__item--color' ) ) {
							elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.querySelector('input').value;
						}

					})
				});

			}, 1000);

			// trigger cart popup 

			if ( this.querySelector('[data-js-quick-buy-form]') ) {
				this.querySelector('form').addEventListener('submit', e=>{

					e.preventDefault();
			
					const submitButton = this.querySelector('[type="submit"]');
					submitButton.classList.add('working');

					window.handleAddToCart(
						this._serializeForm(e.currentTarget), 1,
						{
							'Content-Type': 'application/x-www-form-urlencoded',
							'X-Requested-With': 'XMLHttpRequest'
						},
						()=>{
							submitButton.classList.remove('working');
						}
					);

				});
				
			}

			// update product card prices

			setTimeout(()=>{

				if ( hasProductItem ) {

					const cardPrice = this.closest('[data-js-product-item]').querySelector('[data-js-product-item-price]');
					const buttonPrice = this.querySelector('[data-js-product-add-to-cart-text]');
					const button = this.querySelector('[data-js-product-add-to-cart]')
					const productPrice = this.querySelector('[data-js-quick-buy-product-price]');

					new MutationObserver(()=>{
						if ( cardPrice ) {
							cardPrice.innerHTML = productPrice.innerHTML;
							if ( productPrice.querySelector('[data-js-product-price-original]').textContent != '' ) {
								cardPrice.parentNode.classList.remove('product-item__price--empty');
							} else {
								cardPrice.parentNode.classList.add('product-item__price--empty');
							}
						}
						if ( this.dataset.addToCartPrice == "true" && ! button.classList.contains('disabled') ) {
							buttonPrice.innerHTML = `${buttonPrice.innerHTML} <span class='element--hide-on-small'>- ${productPrice.innerHTML}</span>`;
						}
					}).observe(productPrice, {
						attributes: false, childList: true, subtree: true
					})

				}

				if ( this.dataset.defaultToFirstVariant == 'true' ) {
					this.querySelector('product-variants').updatePrice();
				}

			}, 10);

			this.initializePurchaseTypeListeners();

			// Adding selected selling plan to the cart drawer on change of variant
			this.querySelector('.product-variant__container').addEventListener('change', this.setSellingPlanId.bind(this));

			//calling the function to change variant on change of payment type
			this.querySelector('.product-payment-type--select')?.addEventListener('change', () => {
				this.hideNonSubscriptionVariant();
				this.setSellingPlanId();
			});

			this.hideNonSubscriptionVariant();
			this.setSellingPlanId();
		}

		initializePurchaseTypeListeners(retryCount = 0) {
			if (this.listenersInitialized) {
				return;
			}

			const maxRetries = 3;
			const retryDelay = 100; // ms

			const options = this.querySelectorAll('.purchase_type_options');

			if (options.length === 0 && retryCount < maxRetries) {
				setTimeout(() => {
					this.initializePurchaseTypeListeners(retryCount + 1);
				}, retryDelay);
				return;
			}

			options.forEach(option => {
				const radioInput = option.querySelector('input[type="radio"]');

				if (radioInput) {
					radioInput.addEventListener('change', this.checkVariantSubscription.bind(this));
				} else if (retryCount < maxRetries) {
					setTimeout(() => {
						this.initializePurchaseTypeListeners(retryCount + 1);
					}, retryDelay);
					return;
				} else {
					console.warn('QuickBuy: Could not find radio input for purchase_type_options', option);
				}

				option.addEventListener('keydown', function(e) {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						const radioInput = this.querySelector('input[type="radio"]');
						if (radioInput) {
							radioInput.checked = true;
							radioInput.dispatchEvent(new Event('change', { bubbles: true }));
						}
					}
				});
			});

			if (options.length > 0) {
				this.listenersInitialized = true;
			}
		}

		connectedCallback() {
			if (!this.listenersInitialized) {
				this.initializePurchaseTypeListeners();
			}
		}

		onVariantChangeHandler(e){

			const variant = e.target.currentVariant;

			if ( variant ) {

				if ( this.variantImages ) {
				
					if ( variant.featured_media != null ) {
						const variantImg = this.variantImages.querySelector(`template[data-media-id="${variant.featured_media.id}"]`);
						if ( ! variantImg.dataset.init ) {
							this.initVariantImage(variantImg);
							this.showVariantImage(variant.featured_media.id);
						} else {
							this.showVariantImage(variant.featured_media.id);
						}
					}

				} else if ( this.variantImagesSliders ) {

					if ( variant.featured_image != null && this.productSlider ) {
						const variantImg = this.productSlider.querySelector(`.product-item__image-${variant.featured_image.id}`);
						this.productSlider.changeSlide(variantImg.dataset.index);
					}

				}

			}

		}

		initVariantImage(template) {
			template.dataset.init = true;
			const image = template.content.querySelector('figure').cloneNode(true);
			image.dataset.mediaId = template.dataset.mediaId;
			this.productImage.append(image);
		}

		showVariantImage(id) {
			this.productImage.querySelector('.product-item__image-figure--on-top')?.classList.remove('product-item__image-figure--on-top');
			this.productImage.querySelector(`[data-media-id="${id}"]`).classList.add('product-item__image-figure--on-top');
			this.productImage.querySelector(`[data-media-id="${id}"] img`).srcset = this.productImage.querySelector(`[data-media-id="${id}"] img`).srcset;
			this.productImage.querySelector(`[data-media-id="${id}"]`).style.zIndex = ++this.zIndex;
		}

		_serializeForm(form) {
			let arr = [];
			Array.prototype.slice.call(form.elements).forEach(function(field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function(option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
								'=' +
								encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}

		#getVariantSelect() {
			return this.querySelector('.product-variant-select');
		}

		#initVariantOptionOrder() {
			if (this._variantOptionOrder) return;

			this._variantOptionOrder = Array.from(
				this.querySelectorAll('.product-variant-dropdown-value')
			).map((option) => option.value);
		}

		#getVariantOptionStash() {
			if (!this._variantOptionStash) {
				this._variantOptionStash = document.createElement('div');
				this._variantOptionStash.hidden = true;
				this._variantOptionStash.setAttribute('aria-hidden', 'true');
				this.appendChild(this._variantOptionStash);
			}

			return this._variantOptionStash;
		}

		#showVariantOption(option) {
			if (!option) return;

			const select = this.#getVariantSelect();
			if (!select) return;

			this.#initVariantOptionOrder();
			option.disabled = false;
			option.classList.remove('display-none');
			option.hidden = false;
			option.removeAttribute('hidden');

			if (option.parentElement === select) return;

			const visibleOptions = this.#getVisibleSelectOptions();
			const order = this._variantOptionOrder || [];
			const optionIndex = order.indexOf(option.value);
			let inserted = false;

			for (const visibleOption of visibleOptions) {
				const visibleIndex = order.indexOf(visibleOption.value);
				if (visibleIndex > optionIndex) {
					select.insertBefore(option, visibleOption);
					inserted = true;
					break;
				}
			}

			if (!inserted) {
				select.appendChild(option);
			}
		}

		#hideVariantOption(option) {
			if (!option) return;

			const select = this.#getVariantSelect();
			if (!select || option.parentElement !== select) return;

			option.disabled = true;
			option.classList.add('display-none');
			option.hidden = true;
			this.#getVariantOptionStash().appendChild(option);
		}

		#showAllVariantOptions() {
			const stash = this._variantOptionStash;
			if (!stash) return;

			const stashedOptions = Array.from(
				stash.querySelectorAll('.product-variant-dropdown-value')
			);

			for (const option of stashedOptions) {
				this.#showVariantOption(option);
			}
		}

		#getVisibleSelectOptions() {
			const select = this.#getVariantSelect();
			if (!select) return [];

			return Array.from(select.querySelectorAll('.product-variant-dropdown-value:not([disabled])'));
		}

		hideNonSubscriptionVariant() {
			this.querySelector('input[data-has-subscription-plans]')?.click();
			let variantOptionsForPurchase = 0, installmentOptionCount = 0, normalOptionCount = 0;
			const dropdownContainerOptions = this.querySelectorAll('.product-variant-dropdown-value');
			const paymentTypeDropdown = this.querySelector('.product-payment-type--select');

			// emptying the value of the span which shows the variant if there is only one available
			if (this.querySelector('.selected_subscription_option') !== null) {
				this.querySelector('.selected_subscription_option').innerHTML = "";
			}

			this.#initVariantOptionOrder();
			this.#showAllVariantOptions();
			dropdownContainerOptions.forEach(item => {
				item.classList.remove('display-none');
				item.disabled = false;
			});
			this.querySelectorAll('.product-payment-type--select option').forEach(opt => opt.classList.remove('display-none'));
			this.querySelector('.product-variant-container-box')?.classList.remove('display-none');
			
			// count for the amount of variants
			this.hiddenVariantSelector.forEach(element => {
				if (element.getAttribute('data-subscription') !== "") variantOptionsForPurchase++;
				if (element.getAttribute('data-payment-type') !== "") {
					element.getAttribute('data-payment-type') === this.normalPaymentType ? normalOptionCount++ : installmentOptionCount++;
				}
				if (element.hasAttribute("data-linked_sku-available") && element.dataset.linked_skuAvailable !== "") {
					this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`).setAttribute("data-linked_sku-available",element.dataset.linked_skuAvailable);
				}
			})

			if (normalOptionCount === 0 || installmentOptionCount === 0) {
				const optionPaymentType = normalOptionCount === 0 ? this.normalPaymentType : this.installmentPaymentType;
				this.querySelector(`.product-payment-type--select option[data-payment-type="${optionPaymentType}"]`)?.classList.add("display-none");
				if (paymentTypeDropdown) {
					paymentTypeDropdown.value = this.querySelector('.product-payment-type--select option:not(.display-none)')?.value;
				}
			}

			const paymentTypeValue = paymentTypeDropdown?.value !== "" && paymentTypeDropdown?.value === KROWN.settings.locales.products_payment_type_shipment ? this.normalPaymentType : this.installmentPaymentType;

			if (variantOptionsForPurchase >= 1 ) {
				this.hiddenVariantSelector.forEach(element => {
					if (element.dataset.paymentType === "" || element.dataset.paymentType !== paymentTypeValue) {
						const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`)
						if (variantOption)  {
							this.#hideVariantOption(variantOption);
						}
					};
				})
				
				if (this.querySelector('.product-variant-select')) {
					// Get the currently selected value
					const currentSelectedValue = this.querySelector('.product-variant-select').value;

					// Check if the current selected value is a visible option
					const isCurrentValueValid = !!this.#getVisibleSelectOptions().find(
						(option) => option.value === currentSelectedValue
					);

					// If the current selected value is not valid, set it to the first visible option
					if (!isCurrentValueValid) {
						const firstVisibleOption = this.#getVisibleSelectOptions()[0];
						if (firstVisibleOption) {
							this.querySelector('.product-variant-select').value = firstVisibleOption.value;
						}
					}
				}

				if (variantOptionsForPurchase === 1 || (normalOptionCount === 1 && paymentTypeDropdown.value === KROWN.settings.locales.products_payment_type_shipment) || (installmentOptionCount === 1 && paymentTypeDropdown.value === KROWN.settings.locales.products_payment_type_installment)) {
					this.querySelector('.product-variant-container-box')?.classList.add('display-none');
					if (this.querySelector('.selected_subscription_option')) {
						this.querySelector('.selected_subscription_option').innerHTML = this.querySelector('.product-variant-select')?.value;
					}
				}
			}
			else {
				const oneTimeShipmentRadio = this.querySelector('.one-time-shipment-radio');
				if (oneTimeShipmentRadio) {
					oneTimeShipmentRadio?.click();
					oneTimeShipmentRadio?.classList.add('display-none');
				}
				this.querySelector('.subscription_option')?.classList.add('display-none');
			}
		}

		onClearSubscriptionDetails() {
			const spanElement = document.querySelector('.sub_details');
			const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
			const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
			if (deliveryPolicyIntervalElement) {
				deliveryPolicyIntervalElement.value = "";
			}
			if (deliveryPolicyIntervalCountElement) {
				deliveryPolicyIntervalCountElement.value = "";
			}
			if (spanElement) {
				spanElement.innerHTML = "";
			}
		}

		retrieveDeliveryPolicyByVariantId() {
			const variantId = this.querySelector('.variant-with-selling-plan-allocation')?.value;
			if(!variantId) {
				this.onClearSubscriptionDetails();
				return;
			}
			const apiUrl = KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id
			const spanElement = document.querySelector('.sub_details');
			const mappedIntervalToLocale = {
				"day": KROWN.settings.locales.days,
				"week": KROWN.settings.locales.weeks,
				"month": KROWN.settings.locales.months,
				"year": KROWN.settings.locales.years
			};
			fetch(`${jpapp.proxyUrl}${apiUrl}?variantId=${variantId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
			})
			.then((response) => response.json()).then((sellingPlanInfo) => {
				const { sellingPlan: { deliveryPolicy, originalIntervalCount, sellingPlanType  }, error } = sellingPlanInfo;
				const isInstallment = sellingPlanType === "installment";
				if (error) {
					throw new Error("Error fetching selling plan info");
				}
				
				const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
				const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
				if (deliveryPolicyIntervalElement) {
					deliveryPolicyIntervalElement.value = deliveryPolicy.interval;
				}
				if (deliveryPolicyIntervalCountElement) {
					deliveryPolicyIntervalCountElement.value = isInstallment ? originalIntervalCount : deliveryPolicy.intervalCount;
				}
				const localizedString = KROWN.settings.locales.subscription_details;
				const updatedString = localizedString
					.replace('{{ interval }}', mappedIntervalToLocale[deliveryPolicy.interval.toLowerCase()])
					.replace('{{ intervalCount }}', deliveryPolicy.intervalCount);
				if (spanElement) {
					spanElement.innerHTML = updatedString;
				}
			}).catch((e) => {
				console.log(e);
				this.onClearSubscriptionDetails();
			});
		}

		checkVariantSubscription(event) {
			if (event.target.hasAttribute('data-has-subscription-plans')) {
				this.querySelector('.subscription-payment-type').classList.remove("display-none");
				this.hideNonSubscriptionVariant();
				this.setSellingPlanId();
				this.retrieveDeliveryPolicyByVariantId();
			}
			else {
				this.querySelector('#subscription_type').value = "";
				this.querySelector('#selling_plan_selection').value = "";
				this.querySelector('.selected_subscription_option').innerHTML = "";
				this.querySelector('.product-variant-container-box').classList.remove('display-none');
				this.querySelector('.subscription-payment-type').classList.add('display-none');
				this.#showAllVariantOptions();
				this.querySelectorAll('.product-variant-dropdown-value').forEach(item => {
					item.classList.remove('display-none');
					item.disabled = false;
				});
				this.onClearSubscriptionDetails();
				this.hiddenVariantSelector.forEach(element => {
					if (element.dataset.paymentType === this.installmentPaymentType || element.dataset.oneTimeShipmentDisabled === "true") {
						const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`)
						if (variantOption)  {
							this.#hideVariantOption(variantOption);
						}
					}
				})
				if (this.querySelector('.product-variant-select')) {
					// Get the currently selected value
					const currentSelectedValue = this.querySelector('.product-variant-select').value;

					// Check if the current selected value is a visible option
					const isCurrentValueValid = !!this.#getVisibleSelectOptions().find(
						(option) => option.value === currentSelectedValue
					);

					// If the current selected value is not valid, set it to the first visible option
					if (!isCurrentValueValid) {
						const firstVisibleOption = this.#getVisibleSelectOptions()[0];
						if (firstVisibleOption) {
							this.querySelector('.product-variant-select').value = firstVisibleOption.value;
						}
					}
				}
			}
		}

		setSellingPlanId() {
			const selectedSubscriptionRadioValue = this.querySelector('input[type="radio"]:checked')?.value;
			if (this.querySelector('#subscription_type')) {
				this.querySelector('#subscription_type').value = "";
			}
			if (this.querySelector('#selling_plan_selection')) {
				this.querySelector('#selling_plan_selection').value = "";
			}
			const variantDropdownGet = this.querySelector('.product-variant__container');
			this.querySelectorAll('div[data-subscription]').forEach(element => {
				if (
					element.getAttribute('data-variant-name') === variantDropdownGet.value &&
					element.getAttribute('data-subscription') !== "" &&
					selectedSubscriptionRadioValue === "subscription"
				) {
					this.querySelector('#subscription_type').value = element.getAttribute('data-payment-type');
					this.querySelector('#selling_plan_selection').value = element.getAttribute('data-subscription');
				}
			});
		}
	}

  if ( typeof customElements.get('quick-buy') == 'undefined' ) {
		customElements.define('quick-buy', QuickBuy);
	}

}

if ( ! window.handleAddToCart ) {

	window.handleAddToCart = (body, items, headers, callback) => {
		
		let alert = '';

		const runAdd = async () => {
			let finalBody = body;
			if (typeof window.prepareCartAddBodyWithVariantGlobalIds === 'function') {
				try {
					finalBody = await window.prepareCartAddBodyWithVariantGlobalIds(body, headers);
				} catch (_e) {
					finalBody = body;
				}
			}
			return fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
			body: finalBody,
			headers: headers,
			method: 'POST'
		});
		};

		runAdd()
		.then(response => response.json())
		.then(response => {
			if ( response.status == 422 ) {
				// wrong stock logic alert
				alert = document.createElement('span');
				alert.className = 'alert alert--error';
				alert.innerHTML = response.description
				return fetch('?section_id=helper-cart');
			} else {
				return fetch('?section_id=helper-cart');
			}
		})
		.then(response => response.text())
		.then(text => {

			let doNext = false;

			if ( document.body.classList.contains('template-cart' ) ) {
				doNext = "page";
			} else {
				if ( KROWN.settings.cart_popup == "true" && document.getElementById('mini-cart-popup') ) {
					doNext = "popup";
				} else if ( KROWN.settings.cart_action == "overlay" && document.getElementById('site-cart-sidebar') ) {
					doNext = "drawer";
				} else {
					doNext = "page";
				}
			}

			if ( doNext == "page" ) {
				window.location.href = KROWN.settings.routes.cart_url;
			} else {

				if ( document.getElementById('site-cart-sidebar') ) {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();
					cartItems.initializeSubscriptionDetails();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.innerHTML = document.querySelector('#AjaxCartForm [data-cart-count]').innerHTML;
					});
					document.dispatchEvent(new Event('cart-updated'));

					if ( document.getElementById('cart-recommendations-sidebar') ) {
						document.getElementById('cart-recommendations-sidebar').generateRecommendations();
					}

					if ( alert != '' ) {
						document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
					}
					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					
				}

				if ( doNext == "drawer" ) {
					document.getElementById('site-cart-sidebar').show();
				} else {
					const miniCartPopup = document.getElementById('mini-cart-popup')
					if ( items == 1 ) {
						miniCartPopup.querySelector('[data-js-mini-cart-single]').style.display = 'block';
						miniCartPopup.querySelector('[data-js-mini-cart-plural]').style.display = 'none';
					} else {
						miniCartPopup.querySelector('[data-js-mini-cart-plural]').style.display = 'block';
						miniCartPopup.querySelector('[data-js-mini-cart-plural]').innerHTML = KROWN.settings.locales.cart_added_items_count.replace('{{ count }}', items);
						miniCartPopup.querySelector('[data-js-mini-cart-single]').style.display = 'none';
					}
					miniCartPopup.show();
					const addBtn = document.querySelector('.custom-add-to-cart');
					if ( addBtn ) {
						addBtn.classList.remove('no-click');
						addBtn.querySelector('.button__text').classList.remove('visibility-hidden');
						addBtn.querySelector('.button-loader-container').classList.add('visibility-hidden');
					}
					if ( miniCartPopup.dataset.hide != '0' ) {
						setTimeout(()=>{
							miniCartPopup.hide();
						}, parseInt(miniCartPopup.dataset.hide));
					}
				}
				
			}

		})
		.catch(e => {
			console.log(e);
		})
		.finally(() => {
			callback();
		});

	}

}